import { render, staticRenderFns } from "./CollectByAdministratorDialog.vue?vue&type=template&id=c1ebc906&"
import script from "./CollectByAdministratorDialog.vue?vue&type=script&lang=ts&"
export * from "./CollectByAdministratorDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports